<div class="container">
  <div class="header">
    @if (icon() || data?.icon) {
      <i class="header__icon {{ icon() || data?.icon }}"></i>
    }

    @if (data?.title) {
      <h3 class="header__title">{{ data.title }}</h3>
    }

    @if (closable()) {
      <button class="header__close-dialog" (click)="onCloseClick()">
        <i class="header__close-dialog_icon icon icon-cross"></i>
      </button>
    }
  </div>

  <div class="content">
    <ng-content />
  </div>

  @if (isFooterVisible()) {
    <div class="footer">
      <ng-content select="[footer]" />
    </div>
  }
</div>
